//Built-in libraries
//Third party libraries
import { useParams } from 'react-router';

//Custom components
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
//Services
import { useProject } from '../../../../../../hooks/ReactQueryHooks/useProjectQuery';
import { formatNumber } from '../../../../../../utils';
import { calculateProjectBudgetTotal } from '../../../../../../utils/project';
import ProjectIDSettings from './components/ProjectIDSettings';
import ProjectInfo from './components/ProjectInfo';

//Assets and Miscellaneous

function ProjectHeader() {
  const { projectId } = useParams<string>();
  const fetchProject = useProject({ projectId: parseInt(projectId!, 10) });
  const project = fetchProject?.data?.data;

  const totalProjectBudget =
    project?.sources || project?.budget ? formatNumber(calculateProjectBudgetTotal(project.sources ? project.sources : project.budget)) : 0;
  const totalProjectSubsidies = project?.subsidies ? formatNumber(calculateProjectBudgetTotal(project.subsidies)) : 0;

  return (
    <div className='mb-1 w-full inset-x-0 mx-auto -bottom-20 z-10 flex flex-row flex-col xl:flex-row justify-between gap-4  px-6 bg-white rounded-md shadow-lg items-center'>
      <ProjectInfo />
      <div className='relative border-t py-4 xl:border-l xl:border-t-0 lg:p-4 w-full xl:w-1/4 flex md:flex-row gap-4 justify-between items-start'>
        <div className='space-y-4'>
          <div className='text-center md:text-left'>
            <h4 className='font-bold'>Project Budget</h4>
            <h1 className='text-primaryColor-normal m-0'>
              <CurrencyFormatDisplay value={totalProjectBudget} prefix='$ ' />
            </h1>
          </div>
          <div className='text-center md:text-left'>
            <h4 className='font-bold'>Project Subsidies</h4>
            <h1 className='text-primaryColor-normal m-0'>
              <CurrencyFormatDisplay value={totalProjectSubsidies} prefix='$ ' />
            </h1>
          </div>
        </div>
        <ProjectIDSettings />
      </div>
    </div>
  );
}
export default ProjectHeader;
